import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


/**
 * Format date to dd/mm/aa (Chilean format)
 * Handles: "MM/DD/YY 0", "YYYY-MM-DD", "MM/DD/YY HH:MM:SS", ISO strings
 */
export function fmtFecha(dateStr) {
  if (!dateStr) return '-';
  const s = String(dateStr).replace(/ 0$/, '').replace(' 00:00:00', '').trim();
  if (!s) return '-';

  let d, m, y;

  // ISO: YYYY-MM-DD or YYYY-MM-DDTHH...
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    [y, m, d] = s.substring(0, 10).split('-');
  }
  // MM/DD/YY or MM/DD/YYYY with optional time
  else if (/^\d{1,2}\/\d{1,2}\/\d{2,4}/.test(s)) {
    const parts = s.split(/[\s/]/);
    m = parts[0]; d = parts[1]; y = parts[2];
  }
  else return s;

  d = String(d).padStart(2, '0');
  m = String(m).padStart(2, '0');
  if (y && y.length === 2) y = `20${y}`;

  return `${d}-${m}-${y}`;
}
